import './modalAppliancePreviewVisao.scss';

import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';

import ReactModal from 'react-modal';
import { Visao } from '@visao/viewer-api';

import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { IAppliance } from '../../types';

import closeVisao from '@progymedia/sbi-web-occ/src/images/icons/close-visao.svg';

type ModalAppliancePreviewVisao = {
    isOpen: boolean;
    isStartAR: boolean;
    visaoId: string;
    appliance: IAppliance;
    handleModalClose: () => void;
};

export default function ModalAppliancePreviewVisao(
    props: ModalAppliancePreviewVisao
) {
    const { handleModalClose, isOpen, appliance, isStartAR, visaoId } = props;
    const [visaoStatus, setVisaoStatus] = useState('');
    const isMobile = useMobileDetect().isMobile();
    const { currentLocale } = usePageLocalization();

    const Frame3D = useCallback(
        (param: any) => {
            return (
                <div className='view-visao-appliance-container'>
                    <iframe
                        id='view-visao-appliance'
                        src={`https://demo.visao.ca/viewer/${visaoId}?lang=${param.lang}`}
                        title={param?.title as string}
                        style={{
                            border: 'none',
                            width: '100%',
                            height: '100%',
                        }}
                        allow='autoplay; fullscreen; vr'
                        allowFullScreen
                    />
                </div>
            );
        },
        [appliance?.code, visaoId]
    );

    const MemoizedFrame = useMemo(() => {
        const lang = currentLocale === 'fr_CA' ? 'fr' : 'en';
        return (
            <Frame3D
                title={appliance?.code}
                key={`frame-${appliance?.code}`}
                lang={lang}
            />
        );
    }, [currentLocale, Frame3D, appliance?.code]);

    const visaoAPIRef = useRef<Visao>(
        typeof window !== 'undefined' ? new Visao('view-visao-appliance') : null
    );
    const visaoAPI = useMemo(() => visaoAPIRef.current, [visaoAPIRef]);

    useEffect(() => {
        visaoAPI?.listenToViewerStatus((status) => {
            setVisaoStatus(status);
        });
    }, [visaoAPI]);

    useEffect(() => {
        if (visaoStatus == 'loaded' && isStartAR) {
            if (isMobile) visaoAPI?.startAR();
            else visaoAPI?.showQR();
        }
    }, [visaoStatus, isStartAR]);

    return (
        <ReactModal
            className='modal-appliance-preview-visao'
            isOpen={isOpen}
            onRequestClose={handleModalClose}
            ariaHideApp={false}
        >
            <div className='modal-header' onClick={() => handleModalClose()}>
                <img src={closeVisao} alt='' width={40} height={40} />
            </div>
            {MemoizedFrame}
        </ReactModal>
    );
}
